import React from 'react';
import THEME from '../utils/theme';

export default function SectionTag({ children, center = false }) {
  return (
    <div style={{
      display: 'inline-flex', alignItems: 'center', gap: 8,
      background: THEME.redLight, color: THEME.red,
      fontFamily: "'Syne', sans-serif", fontWeight: 700,
      fontSize: 11, letterSpacing: '0.12em', textTransform: 'uppercase',
      padding: '6px 16px', borderRadius: 2, marginBottom: 20,
      ...(center ? { justifyContent: 'center' } : {}),
    }}>
      <span style={{
        width: 6, height: 6, borderRadius: '50%',
        background: THEME.red, display: 'inline-block', flexShrink: 0,
        animation: 'pulse-dot 1.8s ease-in-out infinite',
      }} />
      {children}
      <style>{`
        @keyframes pulse-dot {
          0%, 100% { transform: scale(1); opacity: 1; }
          50%       { transform: scale(1.4); opacity: 0.7; }
        }
      `}</style>
    </div>
  );
}
